
import { Loader2 } from 'lucide-react';
import { Header } from '../components/Header';
import { BottomNav } from '../components/BottomNav';
import { CameraModal } from '../components/CameraModal';
import { ChallengeStatus } from '../components/ChallengeStatus';

import { PromptVotingSection } from "./challenge/PromptVotingSection";
import { PhotoSubmissionSection } from "./challenge/PhotoSubmissionSection";
import { KingOfTheHillSection } from "./challenge/KingOfTheHillSection";
import { ClosedChallengeSection } from "./challenge/ClosedChallengeSection";
import { useChallengeHandlers } from "./challenge/useChallengeHandlers";
import { useChallengeState } from "./challenge/useChallengeState";

const Challenge = () => {
  const state = useChallengeState();
  const {
    challenge,
    isLoading,
    votedPromptId,
    hasSubmitted,
    isCameraOpen,
    setIsCameraOpen,
    promptVotes,
    hill,
    challengers,
    currentChallenger,
    isVoting,
    handleRefreshStatus,
    user,
    setChallenge,
    setPromptVotes,
    setVotedPromptId,
    setHasSubmitted,
    setHill,
    setChallengers,
    setCurrentChallenger,
    setIsVoting,
    setCurrentMatchup,
    currentMatchup,
  } = state;

  const handlers = useChallengeHandlers({
    user,
    challenge,
    setChallenge,
    setPromptVotes,
    setVotedPromptId,
    setHasSubmitted,
    setHill,
    setChallengers,
    setCurrentChallenger,
    hill,
    challengers,
    currentChallenger,
    setIsVoting,
    setCurrentMatchup,
  });

  const {
    handleVotePrompt,
    handlePhotoCapture,
    handleHillVote,
    handleABVote
  } = handlers;

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col bg-bauhaus-offwhite">
        <Header />
        <div className="flex-1 flex items-center justify-center">
          <Loader2 className="h-8 w-8 text-bauhaus-green animate-spin" />
        </div>
        <div className="h-16"></div>
        <BottomNav />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-bauhaus-offwhite">
      <Header />
      <main className="flex-1 container mx-auto px-3 pt-6 pb-24 max-w-md">
        {challenge && (
          <>
            <ChallengeStatus
              challenge={challenge}
              onStatusChange={handleRefreshStatus}
            />

            {challenge.status === 'voting-prompts' && (
              <PromptVotingSection
                challenge={challenge}
                promptVotes={promptVotes}
                votedPromptId={votedPromptId}
                onVote={handleVotePrompt}
              />
            )}

            {challenge.status === 'submitting' && (
              <PhotoSubmissionSection
                challenge={challenge}
                hasSubmitted={hasSubmitted}
                onOpenCamera={() => setIsCameraOpen(true)}
              />
            )}

            {challenge.status === 'voting-submissions' && (
              <KingOfTheHillSection
                challenge={challenge}
                user={user}
                hill={hill}
                currentChallenger={currentChallenger}
                isVoting={isVoting}
                onHillVote={handleHillVote}
              />
            )}

            {challenge.status === 'closed' && (
              <ClosedChallengeSection
                challenge={challenge}
              />
            )}
          </>
        )}
      </main>
      <CameraModal
        isOpen={isCameraOpen}
        onClose={() => setIsCameraOpen(false)}
        onPhotoCapture={handlePhotoCapture}
      />
      <BottomNav />
    </div>
  );
};

export default Challenge;

